<template>
  <a-row :gutter="24" type="flex">

    <!-- Projects Table Column -->
    <a-col :span="24" class="mb-24">

      <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0}">
        <template #title>
          <a-row type="flex" align="middle">
            <a-col :span="24" :md="12" class="top-left-header">
              <h5 class="font-semibold m-0">
                Tournament List <a-spin v-if="confirmLoading"/>
              </h5>
            </a-col>
            <a-col :span="24" :md="12" class="top-right-header">
              <div class="tournament-end">
                <a-date-picker placeholder="Tournament End"
                               format="YYYY-MM-DD" @change="onDateChange($event)"/>
              </div>
              <a-radio-group v-model="projectHeaderBtns" size="small" @change="onStatusChange">
                <a-radio-button value="all">All</a-radio-button>
                <a-radio-button value="daily">Daily</a-radio-button>
                <a-radio-button value="weekly">Weekly</a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </template>
        <a-table :columns="columnData"
                 :data-source="tournamentList"
                 :pagination="false">

          <template slot="name" slot-scope="text">
            <a>{{ text }}</a>
          </template>

          <template slot="updateBtn" slot-scope="row">
            <div>
              <a-button type="link" :data-id="row.key">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"
                     @click="getLeaderBoard(row.details.id)" v-if="! row.details.is_leaderboard_publish">
                  <path
                      d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z"/>
                </svg>

                <svg width="24"
                     height="24"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     class="bi bi-award-fill"
                     viewBox="0 0 16 16"
                     @click="getGratification(row.details.id)"
                     v-if="row.details.is_leaderboard_publish">
                  <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"/>
                  <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
                </svg>
              </a-button>
            </div>
          </template>
        </a-table>

        <div class="pagination">
          <a-pagination
              v-model:current="currentPage"
              :total="pagination.total"
              :page-size="20"
              :hideOnSinglePage="true"
              @change="onPageChange"
          />
        </div>
      </a-card>

    </a-col>
    <!-- / Projects Table Column -->
  </a-row>
</template>

<script>
import {sendRequest} from '@/http/axios.method';
import moment from "moment/moment"

const COLUMN_DATA = [
  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: {customRender: 'id'},
    width: 90,
  },
  {
    title: 'Game Name',
    dataIndex: 'game_name',
    width: 200,
  },
  {
    title: 'Tournament Name',
    dataIndex: 'tournament_name',
    width: 200,
  },
  {
    title: 'Tournament Type',
    dataIndex: 'tournament_type',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Start Time',
    dataIndex: 'start_time',
    class: 'font-semibold text-muted',
  },
  {
    title: 'End Time',
    dataIndex: 'end_time',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Leaderboard Publish',
    dataIndex: 'is_leaderboard_publish',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Gratified',
    dataIndex: 'is_gratified',
    class: 'font-semibold text-muted',
  },

  {
    title: 'Action',
    scopedSlots: {customRender: 'updateBtn'},
    width: 200,
  },
];

export default {
  name: "Tournament",
  data() {
    return {
      config: {
        'Authorization': 'Bearer ' + this.$store.state.authUser.token
      },
      columnData: COLUMN_DATA,
      tournaments: [],
      projectHeaderBtns: 'all',
      currentPage: 1,
      pagination: {},
      confirmLoading: false,
      selectedDate: '',
    }
  },
  created() {
    this.getTournamentList();
  },
  methods: {
    onDateChange(event) {
      if (!event) {
        this.selectedDate = '';
      } else {
        this.selectedDate = moment(event).format('YYYY-MM-DD');
      }

      this.getTournamentList()
    },
    onStatusChange() {
      this.getTournamentList()
    },
    onPageChange() {
      this.getTournamentList()
    },
    getTournamentList() {
      this.confirmLoading = true;
      let data = {
        page: this.currentPage,
        tournament_type: this.projectHeaderBtns,
        tournament_end: this.selectedDate ,
      }
      sendRequest('get', 'admin/tournament-list', data, this.config)
          .then(response => {
            this.confirmLoading = false;
            if (response.success) {
              let data = response.data.tournaments
              this.tournaments = data.map(function (content, label) {
                return {
                  key: label + 1,
                  id: content.id,
                  tournament_name: content.name,
                  game_name: content.battleGame.name,
                  start_time: content.start_time,
                  end_time: content.end_time,
                  tournament_type: content.type,
                  is_leaderboard_publish: content.is_leaderboard_publish ? 'Yes' : 'No',
                  is_gratified: content.is_gratified ? 'Yes' : 'No',
                  details: content
                };
              });
              this.pagination = response.data.meta.pagination
              this.currentPage = this.pagination.current_page
            } else {
              if (response.status_code === 401) {
                this.$store.dispatch('logout');
                this.$router.push('/login');
              }
            }
          })
          .catch(() => {
            this.confirmLoading = false;
          })
          .finally(() => {
            this.confirmLoading = false;
          })
    },
    getLeaderBoard(tournament_id) {
      this.$router.push({path: '/leaderboard', query: { tournament_id: tournament_id }});
    },
    getGratification(tournament_id) {
      this.$router.push({path: '/gratification', query: { tournament_id: tournament_id }});
    },
  },
  computed: {
    tournamentList: function () {
      return this.tournaments;
    }
  }
}
</script>

<style scoped>

</style>
